import React from "react";
import { useTracking } from "../../../../hooks/useTracking";
import TipoImagenRotacion from "./TipoImagenRotacion";
import TipoTextoPregunta from "./TipoTextoPregunta";
import TipoImgsPregunta from "./TipoImgsPregunta";
import TipoCheckbox from "./TipoCheckbox";
import Button from "../../../Button/Button";
// import "./PreguntasContainer.css";

const PreguntasContainer = ({
  test,
  preguntaActual,
  todasSonCheckbox,
  respuestasCheckbox,
  onResponderPregunta,
  onResponderCheckbox,
  onFinalizarCheckbox,
  className,
}) => {
  console.log(className);
  const { trackEvent } = useTracking();

  const handleAgendarCitaClick = (ubicacion) => {
    trackEvent("agendar_cita_click", {
      test_name: test.titulo,
      pregunta_numero: preguntaActual + 1,
      total_preguntas: test.preguntas.length,
      ubicacion,
    });

    window.open("https://www.apec.org.mx/citas", "_blank", "noopener,noreferrer");
  };

  // Si todas son checkbox, mostrar componente especial
  if (todasSonCheckbox) {
    return (
      <div className={`test-container ${className}`}>
        <h1 className="test-title">{test.titulo}</h1>
        <TipoCheckbox
          test={test}
          respuestasCheckbox={respuestasCheckbox}
          onResponderCheckbox={onResponderCheckbox}
          onFinalizar={onFinalizarCheckbox}
          className={className}
        />
        <Button
          text={"Agendar Cita"}
          className="agendar-cita"
          onClick={() => handleAgendarCitaClick("checkbox_final")}
        />
      </div>
    );
  }

  // Índice de la pregunta "de en medio", sin importar si el total es par o impar
  const totalPreguntas = test.preguntas.length;
  const indiceMedio = Math.floor((totalPreguntas - 1) / 2);
  const mostrarBoton = preguntaActual === indiceMedio;
  // Pregunta individual
  const pregunta = test.preguntas[preguntaActual];

  return (
    <div className={`test-container ${className}`}>
      <h1 className={`test-title ${className}`}>{test.titulo}</h1>

      <div className={`pregunta-card ${className}`}>
        {pregunta.tipo === "imagen-rotacion" && (
          <TipoImagenRotacion
            pregunta={pregunta}
            onResponder={onResponderPregunta}
            className={className}
          />
        )}

        {pregunta.tipo === "textoPregunta" && (
          <TipoTextoPregunta
            pregunta={pregunta}
            onResponder={onResponderPregunta}
            className={className}
          />
        )}

        {pregunta.tipo === "imgsPregunta" && (
          <TipoImgsPregunta
            pregunta={pregunta}
            onResponder={onResponderPregunta}
            className={className}
          />
        )}
      </div>
      {mostrarBoton && (
        <Button
          text={"Agendar Cita"}
          className="agendar-cita"
          onClick={() => handleAgendarCitaClick("pregunta_intermedia")}
        />
      )}
    </div>
  );
};

export default PreguntasContainer;